<script lang="ts">
	import InputText from '../elements/inputs/variants/InputText.svelte';
	import type { InputTextProps } from '../elements/inputs/types';

	export let props: InputTextProps;
	export let containerClasses: string = '';

	props = Object.assign(props, {
		autocomplete: false,
		leadingIcon: 'search',
		withClearAction: props.withClearAction ?? true
	});

	export let action: () => void = null;

	const onKeyPress = (e) => {
		if (action && e.charCode === 13) action();
	};
</script>

<div class="relative {containerClasses}" on:click>
	<InputText bind:props on:keypress={onKeyPress} on:keyup bind:this={props.ref} />
</div>
